import { render, staticRenderFns } from "./SnackbarLayout.vue?vue&type=template&id=a7706fc2"
import script from "./SnackbarLayout.vue?vue&type=script&lang=js"
export * from "./SnackbarLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports